export default ({keys, server, reader}) => `package com.stripe.example;

import com.stripe.stripeterminal.callable.TerminalListener;
import com.stripe.stripeterminal.model.external.ConnectionStatus;
import com.stripe.stripeterminal.model.external.PaymentStatus;
import com.stripe.stripeterminal.model.external.Reader;
import com.stripe.stripeterminal.model.external.ReaderEvent;

import org.jetbrains.annotations.NotNull;

public class TerminalEventListener implements TerminalListener {
    @Override
    public void onConnectionStatusChange(@NotNull ConnectionStatus connectionStatus) {
    }

    @Override
    public void onPaymentStatusChange(@NotNull PaymentStatus paymentStatus) {
    }

    @Override
    public void onUnexpectedReaderDisconnect(@NotNull Reader reader) {
    }
}
`;
